import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import services from '../data/services';
import Navbar from '../components/Navbar';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import FloatingButtons from '../components/FloatingButtons';

const ServiceDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = services.find(s => s.slug === slug);

  const handleBack = () => {
    navigate('/');
    setTimeout(() => {
      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
    }, 150);
  };

  if (!service) {
    return (
      <>
        <Navbar />
        <div className="not-found">
          <h2>Service not found</h2>
          <button onClick={() => navigate('/')} className="back-btn">Back To Home</button>
        </div>
        <Footer />
      </>
    );
  }

  const heroBgStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}${service.image.replace(/ /g, '%20')})`,
  };

  return (
    <>
      <Navbar />

      {/* Hero */}
      <section className="hero">
        <div className="hero-bg" style={heroBgStyle}></div>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <p className="hero-tag">TRUSTED 24/7 TRANSPORT SERVICE</p>
          <h1>{service.title}</h1>
          <p className="hero-desc">With TAXICABS-247, available 24/7.</p>
          <div className="hero-buttons">
            <a href="tel:02038393300" className="hero-btn btn-white">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
              Call Now
            </a>
            <a href="https://booktaxinow.co.uk/" target="_blank" rel="noopener noreferrer" className="hero-btn btn-teal">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15h8v2H8zm0-4h8v2H8z"/></svg>
              Get Quotation
            </a>
            <a href="https://booktaxinow.co.uk/" target="_blank" rel="noopener noreferrer" className="hero-btn btn-red">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/></svg>
              Book Now
            </a>
            <a href="https://booktaxinow.co.uk/" target="_blank" rel="noopener noreferrer" className="hero-btn btn-white">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg>
              Airport Booking
            </a>
          </div>
        </div>
      </section>

      {/* Detail Content */}
      <section className="detail-section">
        <div className="detail-container">
          <p className="section-tag">OUR SERVICES</p>
          <h2 className="section-heading">{service.title}</h2>
          <button onClick={handleBack} className="back-btn">← Back To Services</button>
          <div className="detail-body">
            <div className="detail-img">
              <img src={service.image} alt={service.title} />
            </div>
            <div className="detail-text">
              <p>{service.fullDesc}</p>
            </div>
          </div>
        </div>
      </section>

      <Contact />
      <Footer />
      <FloatingButtons />
    </>
  );
};

export default ServiceDetail;
